import { MIA_WIDGET_VERSION } from './version';

const SENSITIVE =
  /sessiontoken|authorization|api[_-]?key|pepper|secret|password|bearer|mia_ws_|mia_pk_/i;

function scrubValue(key: string, value: unknown): unknown {
  if (SENSITIVE.test(key)) return '[redacted]';
  if (typeof value === 'string' && /^(mia_ws_|mia_pk_)/.test(value)) return '[redacted]';
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return scrubObject(value as Record<string, unknown>);
  }
  return value;
}

export function scrubObject(input: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(input)) {
    out[k] = scrubValue(k, v);
  }
  return out;
}

export class DebugLogger {
  enabled = false;

  enable(on: boolean): void {
    this.enabled = on;
  }

  info(event: string, data?: Record<string, unknown>): void {
    if (!this.enabled || typeof console === 'undefined') return;
    const safe = data ? scrubObject(data) : undefined;
    if (safe) {
      console.info(`[MIA ${MIA_WIDGET_VERSION}]`, event, safe);
    } else {
      console.info(`[MIA ${MIA_WIDGET_VERSION}]`, event);
    }
  }

  warn(event: string, data?: Record<string, unknown>): void {
    if (!this.enabled || typeof console === 'undefined') return;
    const safe = data ? scrubObject(data) : undefined;
    if (safe) {
      console.warn(`[MIA ${MIA_WIDGET_VERSION}]`, event, safe);
    } else {
      console.warn(`[MIA ${MIA_WIDGET_VERSION}]`, event);
    }
  }
}

export const debugLog = new DebugLogger();
